import React from 'react'
import { Link } from "react-router-dom";
import iconCheck from '../assets/images/icons/check.png'
import iconMar from '../assets/images/icons/mar.png'
import iconJuego from '../assets/images/icons/juegos.png'
import iconMotocicleta from '../assets/images/icons/motocicleta.png'
import iconEquipaje from '../assets/images/icons/equipaje.png'

import iconDocumentacion from '../assets/images/icons/documentacion-viajar.png'
import '../css/recomendaciones.scss'

export default function Recomendaciones() {
    return (
        <>
        <section className='recomendacion'>
        <div className='container'>

            <div className='recomendacion-title'>
                <h2 className='title-icon'><i class="fi fi-rs-social-network"></i>  <span>Recomendaciones</span></h2>

            </div>

            <div className='recomendacion-grid'>

                {/* Grande */}
                <div className='recomendacion-box large'>
                    <div className='recomendacion-content-icon'>
                        <img src={iconCheck} alt='' />
                    </div>

                    <div className='recomendacion-content-box'>
                        <div className='recomendacion-content-title'>
                            <label>¿Listo para viajar?</label>
                        </div>

                        <div className='recomendacion-content-text'>
                            <p>
                                Te compartimos una guía rápida con consejos esenciales:
                                horarios, equipaje, seguridad y todo lo que necesitas saber antes de embarcar.
                            </p>
                        </div>

                        <div className='recomendacion-content-cta'>
                            <Link to="/listo-para-viajar">
                                Ver detalles
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Normal */}
                <Link to="/equipaje" className='recomendacion-box'>
                                    
                    <div className='recomendacion-content-icon'>
                        <img src={iconEquipaje} alt='' />
                    </div>

                    <div className='recomendacion-content-box'>
                        <div className='recomendacion-content-title'>
                            <label>Equipaje</label>
                        </div>

                        <div className='recomendacion-content-text'>
                            <p>                                
                                Consulta las condiciones, peso y dimensiones permitidas para tu equipaje.
                            </p>
                        </div>
                    </div>
                </Link>

                {/* Normal */}
                <Link to="/entretenimiento"  className='recomendacion-box'>
                    <div className='recomendacion-content-icon'>
                        <img src={iconJuego} alt='' />
                    </div>

                    <div className='recomendacion-content-box'>
                        <div className='recomendacion-content-title'>
                            <label>Entretenimiento</label>
                        </div>

                        <div className='recomendacion-content-text'>
                            <p>
                                Conoce los servicios de apoyo para un viaje cómodo.
                            </p>
                        </div>
                    </div>
                </Link>

                {/* Alta */}
                
                <Link to="/viajar-con-auto" className='recomendacion-box tall'>
                    <div className='recomendacion-content-icon'>
                        <img src={iconMotocicleta} alt='' />
                    </div>

                    <div className='recomendacion-content-box'>
                        <div className='recomendacion-content-title'>
                            <label>Motos</label>
                        </div>

                        <div className='recomendacion-content-text'>
                            <p>
                                Revisa los pasos para embarcar tu motocicleta de forma segura.
                            </p>
                        </div>
                    </div>
                </Link>

                {/* Banner */}
                <div className='recomendacion-box banner'>
                    <div className='overlay'></div>

                    <div className='recomendacion-banner-content'>
                        <h3>Seguridad a bordo</h3>

                        <p>
                            Nuestra prioridad es tu seguridad. Conoce los protocolos
                            internacionales que seguimos en cada travesía.
                        </p>

                        <a href="https://www.youtube.com/watch?v=SryCbKWhevM&t=301s" target="_blank" rel="noopener noreferrer">
                            Protocolo de Seguridad <i class="fi fi-rr-arrow-up-right-from-square"></i>

                        </a>
                    </div>
                </div>

            </div>
        </div>
        </section>
        </>
    )
}
